(function () {
  angular.module('7Terminal.Core').constant('NabENV', {});
})();
